import {
  MovementType,
  PriceCalculatorFormData,
  SearchEntityType,
} from "@/features/price-calculator/types/types";

const isMultiLegDataCorrect = (formData: PriceCalculatorFormData) => {
  if (formData.routeLegs === undefined) {
    return true;
  }

  const invalidRouteLegsExist = formData.routeLegs?.find((rl) => {
    return rl.departureTime === "";
  });

  return (
    !formData.selectedCustomerNum ||
    !formData.multiLegRouteData?.code ||
    isGoodsSelectionFinished(formData) ||
    isAncillarySelectionFinished(formData) ||
    invalidRouteLegsExist !== undefined
  );
};

const isGoodsSelectionFinished = (data: PriceCalculatorFormData) => {
  if (data.conditionsGoods?.length === 0) {
    return false;
  }

  return data.conditionsGoods?.some((cg) => {
    return cg.goodsCode === "" || isNaN(Number(cg.weight));
  });
};

const isAncillarySelectionFinished = (data: PriceCalculatorFormData) => {
  if (data.conditionsAncillary?.length === 0) {
    return false;
  }

  return data.conditionsAncillary?.some((ca) => {
    return ca.ancillaryCode === "" || ca.quantity < 1 || isNaN(ca.quantity);
  });
};

const isSectionalDataCorrect = (formData: PriceCalculatorFormData) => {
  return (
    !formData.selectedCustomerNum ||
    !formData.routeCode ||
    !formData.sailingDate ||
    !formData.vehicleType ||
    !formData.departureTime ||
    isGoodsSelectionFinished(formData) ||
    isAncillarySelectionFinished(formData)
  );
};

const isBookingDataCorrect = (formData: PriceCalculatorFormData) => {
  return (
    !formData.bookingNumber ||
    formData.version === null ||
    formData.version === undefined
  );
};

export const isCalculationDisabled = (formData: PriceCalculatorFormData) => {
  if (formData.searchEntityType === SearchEntityType.BOOKING) {
    return isBookingDataCorrect(formData);
  } else
    return formData.movementType === MovementType.MULTILEG
      ? isMultiLegDataCorrect(formData)
      : isSectionalDataCorrect(formData);
};
